import { ScreenBase } from "@frui.ts/screens";

export default class ContactViewModel extends ScreenBase {
  constructor() {
    super();
    this.navigationName = "kontakt";
    this.name = "Kontakt";
  }
}
